<template>
  <div>
    <div v-if="success === null">
      {{locale.register.pleaseWait}}
    </div>
    <div v-if="success === true">
      {{locale.register.paymentConfirmed}}
    </div>
    <div v-if="success === false">
      {{locale.register.paymentConfirmationError}}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import errorMessages from '../utils/errorMessages.vue'

export default {
  name: 'RegisterPaymentConfirm',
  components: {errorMessages},
  computed: mapState([
    'locale'
  ]),
  data: function () {
    return {
      orderID: null,
      paymentMethod: null,
      paymentInstrumentID: null,
      success: null
    }
  },
  created () {
    this.$emit('activeStep', 1)
    this.orderID = this.$route.params.orderID
    this.paymentMethod = this.$route.params.paymentMethod
    this.paymentInstrumentID = this.$route.params.paymentInstrumentID
    this.confirmPayment()
  },
  methods: {
    confirmPayment () {
      let orderSplit = this.orderID.split('-')
      let userID = orderSplit[1]
      let data = {
        'user': {
          'id': userID
        },
        'payment': {
          'paymentMethod': this.paymentMethod,
          'paymentInstrumentID': this.paymentInstrumentID,
          'orderID': this.orderID
        }
      }
      this.$store.dispatch('user/confirmPayment', data).then((response) => {
        this.success = response.status === 200
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegisterPaymentConfirm.vue